// extracted by mini-css-extract-plugin
module.exports = {"infoBoxContainer":"tBCCGpNYNQzGs78SNJPGv"};